import { render, staticRenderFns } from "./infoCard_list.vue?vue&type=template&id=1927ef03&scoped=true&"
import script from "./infoCard_list.vue?vue&type=script&lang=js&"
export * from "./infoCard_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1927ef03",
  null
  
)

export default component.exports